<dgx-modal
  [canCancel]="true"
  [useDefaultSubmitButton]="false"
  [useDefaultForm]="false"
  modalHeaderTitle="{{ 'LearningSearch_SearchFilters' | translate }}"
  bodyClasses="dg-modal__body dg-modal__body-scrollable-content"
>
  <!-- Modal Body -->
  <ng-container class="modal-body">
    <dgx-search-filters-sidebar
      *ngIf="!!filters"
      [isModal]="true"
      [isLoading]="false"
      [filters]="filters"
      (filtersChange)="onFiltersChange($event)"
    ></dgx-search-filters-sidebar>
  </ng-container>

  <!-- Modal Footer -->
  <ng-container class="modal-footer">
    <button
      df-button
      dfButtonType="primary"
      type="submit"
      data-dgat="search-mobile-filters-modal-14a"
      (click)="onSubmit()"
    >
      {{ 'Core_ShowResults' | translate }}
    </button>
  </ng-container>
</dgx-modal>
